// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn {
    padding-left: 2rem;
    padding-right: 2rem;
}

.btn-outline-primary {
    border: 1px solid #dbc700;
    color: black;
    background: transparent;
}

.btn-outline-primary:hover,
.btn-outline-primary:active {
    background: #dbc700;
    color: white;
}

.require-label:after {
    content: ' *';
    color: red;
}

.p-component:disabled {
    opacity: 1;
}

.p-disabled, .p-component:disabled {
    opacity: 1!important;
}

.readonly-block {
    /*padding: .5rem;*/
    /*border-bottom: 1px dashed;*/
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInRlYW0taW5mby5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQTtJQUNJLGtCQUFrQjtJQUNsQixtQkFBbUI7QUFDdkI7O0FBRUE7SUFDSSx5QkFBeUI7SUFDekIsWUFBWTtJQUNaLHVCQUF1QjtBQUMzQjs7QUFFQTs7SUFFSSxtQkFBbUI7SUFDbkIsWUFBWTtBQUNoQjs7QUFFQTtJQUNJLGFBQWE7SUFDYixVQUFVO0FBQ2Q7O0FBRUE7SUFDSSxVQUFVO0FBQ2Q7O0FBRUE7SUFDSSxvQkFBb0I7QUFDeEI7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsNkJBQTZCO0FBQ2pDIiwiZmlsZSI6InRlYW0taW5mby5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiXG4uYnRuIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDJyZW07XG4gICAgcGFkZGluZy1yaWdodDogMnJlbTtcbn1cblxuLmJ0bi1vdXRsaW5lLXByaW1hcnkge1xuICAgIGJvcmRlcjogMXB4IHNvbGlkICNkYmM3MDA7XG4gICAgY29sb3I6IGJsYWNrO1xuICAgIGJhY2tncm91bmQ6IHRyYW5zcGFyZW50O1xufVxuXG4uYnRuLW91dGxpbmUtcHJpbWFyeTpob3Zlcixcbi5idG4tb3V0bGluZS1wcmltYXJ5OmFjdGl2ZSB7XG4gICAgYmFja2dyb3VuZDogI2RiYzcwMDtcbiAgICBjb2xvcjogd2hpdGU7XG59XG5cbi5yZXF1aXJlLWxhYmVsOmFmdGVyIHtcbiAgICBjb250ZW50OiAnIConO1xuICAgIGNvbG9yOiByZWQ7XG59XG5cbi5wLWNvbXBvbmVudDpkaXNhYmxlZCB7XG4gICAgb3BhY2l0eTogMTtcbn1cblxuLnAtZGlzYWJsZWQsIC5wLWNvbXBvbmVudDpkaXNhYmxlZCB7XG4gICAgb3BhY2l0eTogMSFpbXBvcnRhbnQ7XG59XG5cbi5yZWFkb25seS1ibG9jayB7XG4gICAgLypwYWRkaW5nOiAuNXJlbTsqL1xuICAgIC8qYm9yZGVyLWJvdHRvbTogMXB4IGRhc2hlZDsqL1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/containers/team-info/team-info.component.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,wvCAAwvC","sourcesContent":["\n.btn {\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n\n.btn-outline-primary {\n    border: 1px solid #dbc700;\n    color: black;\n    background: transparent;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:active {\n    background: #dbc700;\n    color: white;\n}\n\n.require-label:after {\n    content: ' *';\n    color: red;\n}\n\n.p-component:disabled {\n    opacity: 1;\n}\n\n.p-disabled, .p-component:disabled {\n    opacity: 1!important;\n}\n\n.readonly-block {\n    /*padding: .5rem;*/\n    /*border-bottom: 1px dashed;*/\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
